import { useContext } from "react";
import { FeatureFiltersContext } from "./FeatureFiltersProvider";

export default function useFeatureFiltersContext() {
    return useContext(FeatureFiltersContext);
};
